import App from './App.svelte';
import MoveToCollectionForm from './MoveToCollectionForm.svelte';

const props = {
	frontend_endpoint: '/api',
	backend_endpoint: 'http://158.108.168.11:5002',
	token: 'some-test-token',
	username: 'username',
	roles: [],
	...window.clientConfig,
};
let app;
const collectionForm = document.getElementById('move-to-collection-form');
if (collectionForm) {
	app = new MoveToCollectionForm({
		target: collectionForm,
		props,
	})
} else {
	app = new App({
		target: document.body,
		props,
	});
}

export default app;